import Breakpoints from 'breakpoints-js/src/breakpoints';
import mediaLazyLoad from '../utils/rbata.mediaLazyLoad';
import parallax from '../utils/rbata.parallax';

const featureCards = {
    sliderSelector:   '.js-featurecard-carousel',
    $sliderContainer: $('.js-featurecard-carousel'),
    sliders:          [],
    buildSlider(slider, nav) {
        this.sliders.push(tns({
            container:         slider,
            mode:              'carousel',
            items:             4,
            slideBy:           4,
            loop:              0,
            controls:          true,
            controlsContainer: nav,
            nav:               false,
            arrowKeys:         true,
            speed:             500,
            lazyload:          false,
            mouseDrag:         false,
            onInit:            () => {
                slider.classList.remove('featurecard-carousel--not-initialized');
                nav.classList.remove('d-none');
                mediaLazyLoad.refreshLazyLoad();
                parallax.reloadParallaxPool();
            },
        }));
    },
    destroySlider() {
        if (this.slider && typeof (this.slider.destroy) === typeof (Function)) {
            this.slider.destroy();
        }
    },
    buildAllSliders() {
        this.$sliderContainer.each((index, item) => {
            if (item.childElementCount > 4) {
                //show the arrow if we have more products
                this.buildSlider(item, $(item).next('nav')[0]);
            }
        })
    },
    destroyAllSliders() {
        this.sliders.forEach((tns) => {
            if (tns && typeof (tns.destroy) === typeof (Function)) {
                tns.destroy();
                setTimeout(() => {
                    mediaLazyLoad.refreshLazyLoad();
                }, 0)
            }
        });
        this.sliders          = [];
        this.$sliderContainer = $(this.sliderSelector);
    },
    bindHandler() {
        Breakpoints.on('desktop', {
            enter: () => {
                featureCards.buildAllSliders();
            },
            leave: () => {
                featureCards.destroyAllSliders();
            }
        });
    }
};

// DOM ready
$(() => {
    if (featureCards.$sliderContainer.length) {
        featureCards.bindHandler();
    }
});

export default featureCards;
